// Canonical event_id construction. Shared with the browser beacon so both
// sides produce identical ids without coordination.

export type EventName = 'Lead' | 'Purchase';

export function buildEventId(eventName: EventName, visitorId: string, vendorEventId: string): string {
  return `${eventName.toLowerCase()}_${visitorId}_${vendorEventId}`;
}

export function buildEventIdFallback(eventName: EventName, vendorEventId: string): string {
  return `${eventName.toLowerCase()}_${vendorEventId}`;
}
